<template>
  <Toast />
  <div class="card-header row">
    <h4 class="col-md-10" v-if="!fromMovimientos">Carga Manual de Movimientos</h4>
    <h4 class="col-md-10" v-else>Detalle Movimiento # {{ movid }}</h4>
    <div class="col-md-2" style="text-align:right;">
      <router-link to="/movimientos" class="nav-link">
        <Button label="Volver" icon="pi pi-arrow-left" class="p-button-danger" id="volver"/>
      </router-link>      
    </div>
    <div class="line_title mt-1 ms-2 col-md-1"></div>
  </div>
  <div class="card-body">
    <div class="row">
      <div :class="fromMovimientos ? 'col-md-12' : 'col-md-8'">
        <div class="col-12 m-1 p-4 rounded-1 border border-1 bg-white">
          <form class="p-fluid" id="form_movimiento">
            <div class="row mt-1">          
              <div class="field col-md-5">
                <label for="chofer">Chofer</label>
                  <AutoComplete id="chofer" v-model="v$.chofer.$model"
                  :class="{ 'p-invalid': v$.chofer.$invalid && submitted }" :suggestions="filteredChoferes"
                  @complete="searchChofer($event)" field="_nombre" :dropdown="true" forceSelection
                  aria-describedby="chofer-error" autofocus autocomplete="off"/>
                <span v-if="v$.chofer.$error && submitted">
                  <span id="chofer-error" v-for="(error, index) of v$.chofer.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="((v$.chofer.$invalid && submitted) || v$.chofer.$pending.$response)"
                  class="p-error">
                  {{ v$.chofer.required.$message.replace('Value', 'Chofer') }}</small>              
              </div>
              
              <div class="field col-md-5">
                <label for="tmovimiento">Tipo Movimiento</label>
                <AutoComplete id="tmovimiento" v-model="v$.tmovimiento.$model"
                :class="{ 'p-invalid': v$.tmovimiento.$invalid && submitted }" :suggestions="filteredTMovimientos"
                @complete="searchTMovimiento($event)" field="_nombre" :dropdown="true" forceSelection
                @change="valorizar($event,'tmovimiento')" aria-describedby="tmovimiento-error" autofocus autocomplete="off"/>
                <span v-if="v$.tmovimiento.$error && submitted">
                  <span id="tmovimiento-error" v-for="(error, index) of v$.tmovimiento.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="((v$.tmovimiento.$invalid && submitted) || v$.tmovimiento.$pending.$response)"
                  class="p-error">
                  {{ v$.tmovimiento.required.$message.replace('Value', 'Tipo Movimiento') }}</small>               
              </div>    
              <div class="col-md-2 field">
                <label for="fecha">Fecha Movimiento</label>
                <Calendar id="fecha" v-model="v$.fecha.$model" 
                  :class="{ 'p-invalid': v$.fecha.$invalid && submitted }" aria-describedby="fecha-error"
                  autocomplete="off" :showIcon="true" dateFormat="dd/mm/yy"/>
                <span v-if="v$.fecha.$error && submitted">
                  <span id="fecha-error" v-for="(error, index) of v$.fecha.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="(v$.fecha.$invalid && submitted) || v$.fecha.$pending.$response"
                  class="p-error">
                  {{ v$.fecha.required.$message.replace('Value', 'Fecha Movimiento') }}</small>
              </div>                
            </div>  

            <div class="row mt-4" v-if="es_normal">
              <div class="col-md-12 field">
                <b class="text-muted">Datos del Documento</b>
              </div> 

              <div class="col-md-3 field mt-2">
                <label for="proveedor">Emisor</label>
                <AutoComplete id="proveedor" v-model="v$.proveedor.$model"
                  :class="{ 'p-invalid': v$.proveedor.$invalid && submitted && es_normal}" :suggestions="filteredProveedores"
                  @complete="searchProveedor($event)" field="_razon_social" :dropdown="true" forceSelection
                  aria-describedby="proveedor-error" autofocus autocomplete="off"/>
                <span v-if="v$.proveedor.$error && submitted && es_normal">
                  <span id="proveedor-error" v-for="(error, index) of v$.proveedor.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="((v$.proveedor.$invalid && submitted && es_normal) || v$.proveedor.$pending.$response)"
                  class="p-error">
                  {{ v$.proveedor.required.$message.replace('Value', 'Proveedor') }}</small>
              </div>

              <div class="col-md-3 field mt-2">
                <label for="cliente">Receptor</label>
                <AutoComplete id="cliente" v-model="v$.cliente.$model"
                  :class="{ 'p-invalid': v$.cliente.$invalid && submitted }" :suggestions="filteredClientes"
                  @complete="searchCliente($event)" field="_razon_social" :dropdown="true" forceSelection
                  aria-describedby="cliente-error" autofocus autocomplete="off"/>
                <span v-if="v$.cliente.$error && submitted">
                  <span id="cliente-error" v-for="(error, index) of v$.cliente.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="((v$.cliente.$invalid && submitted) || v$.cliente.$pending.$response)"
                  class="p-error">
                  {{ v$.cliente.required.$message.replace('Value', 'Cliente') }}</small>
              </div> 

              <div class="col-md-2 field mt-2">
                <label for="tipoDocumento">Tipo Doc</label>
                <AutoComplete id="tipoDocumento" v-model="v$.tipoDocumento.$model"
                  :class="{ 'p-invalid': v$.tipoDocumento.$invalid && submitted }" :suggestions="filteredTipoDocumentos"
                  @complete="searchTipoDocumento($event)" field="_nombre" :dropdown="true" forceSelection
                  aria-describedby="tipoDocumento-error" autofocus autocomplete="off" />
                <span v-if="v$.tipoDocumento.$error && submitted">
                  <span id="tipoDocumento-error" v-for="(error, index) of v$.tipoDocumento.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="((v$.tipoDocumento.$invalid && submitted) || v$.tipoDocumento.$pending.$response)"
                  class="p-error">
                  {{ v$.tipoDocumento.required.$message.replace('Value', 'Tipo Documento') }}</small>
              </div>

              <div class="col-md-2 field mt-2">
                <label for="fecha_emision">Fecha Doc</label>
                <Calendar id="fecha_emision" v-model="v$.fecha_emision.$model" 
                  :class="{ 'p-invalid': v$.fecha_emision.$invalid && submitted }" aria-describedby="fecha_emision-error"
                  autocomplete="off" :showIcon="true" dateFormat="dd/mm/yy"/>
                <span v-if="v$.fecha_emision.$error && submitted">
                  <span id="fecha_emision-error" v-for="(error, index) of v$.fecha_emision.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="(v$.fecha_emision.$invalid && submitted) || v$.fecha_emision.$pending.$response"
                  class="p-error">
                  {{ v$.fecha_emision.required.$message.replace('Value', 'Fecha Documento') }}</small>
              </div>          
                        
              <div class="col-md-2 field mt-2">
                <label for="folio">Folio</label>
                <InputNumber id="folio" v-model="v$.folio.$model" :class="{ 'p-invalid': v$.folio.$invalid && submitted }"
                  aria-describedby="folio-error" autofocus autocomplete="off" />
                <span v-if="v$.folio.$error && submitted">
                  <span id="folio-error" v-for="(error, index) of v$.folio.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="(v$.folio.$invalid && submitted) || v$.folio.$pending.$response" class="p-error">
                  {{ v$.folio.required.$message.replace('Value', 'Valor') }}</small>
              </div>
            </div>

            <div class="row mt-4" v-if="es_normal">
              <div class="col-md-12 field">
                <b class="text-muted">Datos del Transporte</b>
                <InlineMessage v-for="msg of messages" :key="msg.id" severity="warn">{{ msg.content }}</InlineMessage>            
              </div>
              <div class="col-md-4 field mt-2">
                <label for="origen">Origen</label>
                <AutoComplete id="origen" v-model="v$.origen.$model"
                  :class="{ 'p-invalid': v$.origen.$invalid && submitted }" :suggestions="filteredOrigenes"
                  @complete="searchOrigen($event)" field="_descripcion" :dropdown="true" forceSelection 
                  @change="valorizar($event,'origen')"
                  aria-describedby="origen-error" autofocus autocomplete="off"/>
                <span v-if="v$.origen.$error && submitted">
                  <span id="origen-error" v-for="(error, index) of v$.origen.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="((v$.origen.$invalid && submitted) || v$.origen.$pending.$response)"
                  class="p-error">
                  {{ v$.origen.required.$message.replace('Value', 'Origen') }}</small>
              </div>           
              <div class="col-md-4 field mt-2">
                <label for="destino">Destino</label>
                <AutoComplete id="destino" v-model="v$.destino.$model"
                  :class="{ 'p-invalid': v$.destino.$invalid && submitted }" :suggestions="filteredDestinos"
                  @complete="searchDestino($event)" field="_descripcion" :dropdown="true" forceSelection 
                  @change="valorizar($event,'destino')"
                  aria-describedby="destino-error" autofocus autocomplete="off" />
                <span v-if="v$.destino.$error && submitted">
                  <span id="destino-error" v-for="(error, index) of v$.destino.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="((v$.destino.$invalid && submitted) || v$.destino.$pending.$response)"
                  class="p-error">
                  {{ v$.destino.required.$message.replace('Value', 'Destino') }}</small>
              </div>           
              <div class="col-md-4 field mt-2">
                <label for="producto">Material</label>
                <AutoComplete id="producto" v-model="v$.producto.$model"
                  :class="{ 'p-invalid': v$.producto.$invalid && submitted }" :suggestions="filteredProductos"
                  @complete="searchProducto($event)" field="_nombre" :dropdown="true" forceSelection
                  aria-describedby="producto-error" autofocus autocomplete="off" />
                <span v-if="v$.producto.$error && submitted">
                  <span id="producto-error" v-for="(error, index) of v$.producto.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="((v$.producto.$invalid && submitted) || v$.producto.$pending.$response)"
                  class="p-error">
                  {{ v$.producto.required.$message.replace('Value', 'Material') }}</small>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-4 field">
                <label for="tcamion" class="mt-2">Tipo Camión</label>
                <AutoComplete id="tcamion" v-model="v$.tcamion.$model"
                  :class="{ 'p-invalid': v$.tcamion.$invalid && submitted }" :suggestions="filteredTCamiones"
                  @complete="searchTCamion($event)" field="_nombre" :dropdown="true" forceSelection
                  @change="valorizar($event,'tcamion')" aria-describedby="tcamion-error" autofocus autocomplete="off" />
                <span v-if="v$.tcamion.$error && submitted">
                  <span id="tcamion-error" v-for="(error, index) of v$.tcamion.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="((v$.tcamion.$invalid && submitted) || v$.tcamion.$pending.$response)"
                  class="p-error">
                  {{ v$.tcamion.required.$message.replace('Value', 'Tipo Camión') }}</small>
              </div>          
              <div class="col-md-4 field mt-2">
                <label for="patente_camion">Patente Camion</label>
                <InputText id="patente_camion" v-model="v$.patente_camion.$model" :class="{ 'p-invalid': v$.patente_camion.$invalid && submitted }"
                  aria-describedby="patente_camion-error" autocomplete="off" minlength="6" maxlength="6" size="6" @update:modelValue="upperCase($event,'patente_camion')"/>
                <span v-if="v$.patente_camion.$error && submitted">
                  <span id="patente_camion-error" v-for="(error, index) of v$.patente_camion.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="(v$.patente_camion.$invalid && submitted) || v$.patente_camion.$pending.$response" class="p-error">
                  {{ v$.patente_camion.required.$message.replace('Value', 'Valor') }}</small>
              </div>
              <div class="col-md-2 field mt-2">
                <label for="precio">Precio</label>
                <InputNumber id="precio" v-model.trim="form.precio" :useGrouping="true" />
              </div>
              <div class="col-md-2 field mt-2">
                <label for="monto_total">Monto Docto</label>
                <InputNumber id="monto_total" v-model="v$.monto_total.$model" :class="{ 'p-invalid': v$.monto_total.$invalid && submitted }"
                  aria-describedby="monto_total-error" autofocus autocomplete="off" />
                <span v-if="v$.monto_total.$error && submitted">
                  <span id="monto_total-error" v-for="(error, index) of v$.monto_total.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="(v$.monto_total.$invalid && submitted) || v$.monto_total.$pending.$response" class="p-error">
                  {{ v$.monto_total.required.$message.replace('Value', 'Valor') }}</small>
              </div>                                    
            </div>

            <div class="row mt-4">
              <div class="col-md-12 field">
                <label for="observacion" class="mt-3">Observaciones</label>
                <Textarea autoResize id="observacion" v-model.trim="form.observacion" />
              </div>                   
            </div>
          </form>
        
          <div class="row">
            <div class="col-md-8 fw-lighter text-muted field mt-2" style="text-align: left;">
            Tipo Registro: &nbsp;<Tag :value="form.tipo_registro" severity="info" />
            </div> 
            <div class="col-md-4 field mt-2" v-if="!saving" style="text-align: right;">
              <Button label="Cancelar" icon="pi pi-times" class="p-button-text text-muted me-4" @click="clearForm" />
              <Button v-if="form.id" label="Eliminar" icon="pi pi-trash" class="p-button-text text-danger ms-4" @click="confirmDeleteMovimiento"/>
              <Button label="Guardar" icon="pi pi-check" class="p-button-text" @click="saveMovimiento"/>
            </div>
            <div :class="form.created_id ? 'col-md-5 field' : 'col-md-5 field'" v-else>
              <ProgressBar mode="indeterminate"/>
            </div>
          </div>
        </div>
        <span id="dummy"></span>
      </div>
      <div class="col-md-4" v-if="!fromMovimientos">
        <div class="col-12 p-fluid m-1 p-4 rounded-1 border border-1 bg-white">
          <DataTable ref="dtp" :value="movimientos" :paginator="true" :rows="10" style="zoom: 0.8" 
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
          responsiveLayout="scroll" breakpoint="990px"
          @rowSelect="editMovto($event)" selectionMode="single">          
            <Column field="id" header="#" >
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.id }}
                </span>
              </template>
            </Column>
            <Column field="nombre" header="Tipo" >
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.nombre }}
                </span>
              </template>
            </Column>
            <Column field="fecha" header="Fecha" >
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.fecha }}
                </span>
              </template>
            </Column>
            <Column field="valor" header="Valor" style="text-align: right">
              <template #body="slotProps">
                <span>
                  {{ formatCurrency(slotProps.data.valor, false) }}
                </span>
              </template>
            </Column>
          </DataTable>           
        </div>
      </div>
    </div>
    <!-- Confirmar elimina un movimiento -->
    <Dialog v-model:visible="deleteMovimientoDialog" :style="{ width: '470px' }" header="Confirmar" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-3 text-warning" style="font-size: 2rem; vertical-align: middle;" />
        <span v-if="form.id"> ¿Está seguro de borrar el movimiento #{{form.id}}?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteMovimientoDialog = false" />
        <Button label="Si" icon="pi pi-check" class="p-button-text text-danger" @click="deleteMovimiento" />
      </template>
    </Dialog>

    <!-- Confirmar elimina masivamente movimientos -->
    <Dialog v-model:visible="deleteMovimientosDialog" :style="{ width: '470px' }" header="Confirmar" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-2 text-warning" style="font-size: 2rem; vertical-align: middle;" />
        <span v-if="selectedMovimientos"> ¿Está seguro de borrar los movimientos seleccionados?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteMovimientosDialog = false" />
        <Button label="Si" icon="pi pi-check" class="p-button-text text-danger" @click="deleteSelectedMovimientos" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import useCargaManual from '../../composables/movimientos/cmanual'
import { reactive, ref, onMounted, computed, isProxy, toRaw, watch } from 'vue'
import moment from 'moment'
import useVuelidate from '@vuelidate/core'
import { required, requiredIf, helpers } from '@vuelidate/validators'

export default {
  data() {
		return {
			userRole: window.Laravel.user.seg_rol_id,
		}
	},
  setup() {
    const {
      tmovimientos,
      chofer,
      client,
      movimiento,
      choferes,
      tcamiones,
      proveedores,
      clientes,
      tipoDocumentos,
      destinos,
      origenes,
      dt,
      loading,
      saving,
      filters,
      router,
      initFilters,
      selectedMovimientos,
      deleteMovimientosDialog,
      deleteMovimientoDialog,
      movimientoDialog,
      submitted,
      filteredProveedores,
      filteredClientes,
      filteredChoferes,
      filteredTCamiones,
      filteredTMovimientos,
      filteredTipoDocumentos,
      filteredDestinos,
      filteredOrigenes,
      filteredProductos,
      selectedProductos,
      productos,
      lineas,
      messages,
      deleteSelectedMovimientos,
      storeMovimiento,
      deleteMovimiento,
      first,
      lazyParams,
      cmanual,
      onPage,
      onSort,
      onFilter,
      movimientos,
      getMovimiento
    } = useCargaManual()

    const movid = ref()
    const es_normal = ref()
    const precio = ref(0)
    const fromMovimientos = ref(false)
    
    const oldTMadera = reactive({})

    const frmchofer = reactive({
      'label' : '+ Chofer',
      'visible' : false,
      'color' : 'text-success mt-4'
    })

    const form = reactive({
      id: null,
      tipoDocumento: null,
      precio: 0,
      proveedor: null,
      cliente: null,
      origen: null,      
      destino: null,
      chofer: null,
      tmovimiento: null,
      tcamion: null,
      folio: null,
      monto_total: null,
      producto: null,
      fecha_emision: null,
      fecha: moment().toDate(),
      patente_camion: '',
      observacion: '',
      tipo_registro: 'WEB'
    })

    const rules = {
      chofer: { required: helpers.withMessage('El campo es requerido!', required), },
      tmovimiento: { required: helpers.withMessage('El campo es requerido!', required), },
      tcamion: { required: helpers.withMessage('El campo es requerido!', required), }, 
      fecha: { required: helpers.withMessage('El campo es requerido', required), }, 
      patente_camion: { required: helpers.withMessage('El campo es requerido', required), },   
      precio: { required: helpers.withMessage('El campo es requerido', required), }, 
      tipoDocumento: { required: helpers.withMessage('El campo es requerido', requiredIf(() => form.tmovimiento.tipo === 'NORMAL')), },
      proveedor: { required: helpers.withMessage('El campo es requerido', requiredIf(() => form.tmovimiento.tipo === 'NORMAL')), },
      cliente: { required: helpers.withMessage('El campo es requerido', requiredIf(() => form.tmovimiento.tipo === 'NORMAL')), },
      origen: { required: helpers.withMessage('El campo es requerido', requiredIf(() => form.tmovimiento.tipo === 'NORMAL')), },
      destino: { required: helpers.withMessage('El campo es requerido', requiredIf(() => form.tmovimiento.tipo === 'NORMAL')), },
      monto_total: { required: helpers.withMessage('El campo es requerido', requiredIf(() => form.tmovimiento.tipo === 'NORMAL')), },
      folio: { required: helpers.withMessage('El campo es requerido', requiredIf(() => form.tmovimiento.tipo === 'NORMAL')), },
      producto: { required: helpers.withMessage('El campo es requerido', requiredIf(() => form.tmovimiento.tipo === 'NORMAL')), },
      fecha_emision: { required: helpers.withMessage('El campo es requerido', requiredIf(() => form.tmovimiento.tipo === 'NORMAL')), },
    }

    const confirmDeleteSelected = () => {
      deleteMovimientosDialog.value = true
    }

    const confirmDeleteMovimiento = () => {
      deleteMovimientoDialog.value = true
    }

    const searchTMovimiento = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredTMovimientos.value = [...tmovimientos.value]
        }
        else {
          filteredTMovimientos.value = tmovimientos.value.filter((tmov) => {
            return tmov._nombre.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchTipoDocumento = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredTipoDocumentos.value = [...tipoDocumentos.value]
        }
        else {
          filteredTipoDocumentos.value = tipoDocumentos.value.filter((tdocumento) => {
            return tdocumento._nombre.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchProveedor = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredProveedores.value = [...proveedores.value]
        }
        else {
          filteredProveedores.value = proveedores.value.filter((proveedor) => {
            return proveedor._razon_social.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchCliente = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredClientes.value = [...clientes.value]
        }
        else {
          filteredClientes.value = clientes.value.filter((cliente) => {
            return cliente._razon_social.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchChofer = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredChoferes.value = [...choferes.value]
        }
        else {
          filteredChoferes.value = choferes.value.filter((chofer) => {
            return chofer._nombre.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchDestino = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredDestinos.value = [...destinos.value]
        }
        else {
          filteredDestinos.value = destinos.value.filter((destino) => {
            return destino._descripcion.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchOrigen = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredOrigenes.value = [...origenes.value]
        }
        else {
          filteredOrigenes.value = origenes.value.filter((origen) => {
            return origen._descripcion.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchProducto = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredProductos.value = [...productos.value]
        }
        else {
          filteredProductos.value = productos.value.filter((producto) => {
            return producto._nombre.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }  

    const searchTCamion = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredTCamiones.value = [...tcamiones.value]
        }
        else {
          filteredTCamiones.value = tcamiones.value.filter((tcam) => {
            return tcam._nombre.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }   

    const formatCurrency = (value, style = true) => {
      return style ? new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(Number(value))
        : new Intl.NumberFormat('es-CL').format(Number(value))
    }

    const formatFecha = (value) => {
      return moment(value).format("DD/MM/YYYY")
    }

    const toggleDelete= (index) => {
      lineas.value.splice(index, 1)
      messages.value = []
    }

    const upperCase = ($event, field) => {
      form[field] = $event.toUpperCase()
    }    

    const saveMovimiento = () => {
      submitted.value = true
      if(!v$._value.$invalid){
        storeMovimiento(form)
      }
    }

    const setDocumento = (event) => {
      es_normal.value = event.value.tipo === 'NORMAL'
    }

    const getPrecioMovimiento = async (frm) => {
      form.precio = 0
      precio.value = 0
      loading.value = true

      let origen = frm.origen === null || frm.origen === undefined ? null : frm.origen.id
      let destino = frm.destino === null || frm.destino === undefined ? null : frm.destino.id
      let tcamid = frm.tcamion !== undefined || frm.tcamion !== null || frm.tcamion !== '' ? frm.tcamion.id : null

      if(es_normal.value === true){
        if(frm.tmovimiento !== undefined && origen > 0 && destino > 0 && tcamid > 0){
          client.get(`/api/mprecios/${frm.tmovimiento.id}/${tcamid}/${origen}/${destino}/precios`)
          .then(response => {
            precio.value = response.data.data.precio[0].precio
            form.precio = precio.value
            loading.value = false
          })
        }
      }else{
        if(frm.tmovimiento !== undefined && tcamid > 0){
          client.get(`/api/mprecios/${frm.tmovimiento.id}/${tcamid}/${origen}/${destino}/precios`)
          .then(response => {
            precio.value = response.data.data.precio[0].precio
            form.precio = precio.value
            loading.value = false
          })
        }        
      }
    }
    
    const valorizar = (event, ele) => {
      console.info(form)
      messages.value = []
      if(ele === 'tmovimiento') setDocumento(event)
      if(form.tmovimiento.tipo === 'NORMAL'){
        //es obligatorio origen-destino para obtener el precio
        if(form.origen !== null && form.origen !== undefined && form.origen !== '' && form.destino !== null && form.destino !== undefined && form.destino !== '' && form.tcamion !== null && form.tcamion !== undefined && form.tcamion !== ''){
          getPrecioMovimiento(form)
          form.precio = precio.value
        }else
          messages.value = [{ content: 'Debe seleccionar el origen, destino y camión para obtener el precio', id: 0 }]
      }else
        if(form.tcamion !== null && form.tcamion !== undefined && form.tcamion !== ''){
          form.origen = null
          form.destino = null
          getPrecioMovimiento(form)
          form.precio = precio.value
        }     
    }    

    const dummyClick = () => {
      document.getElementById('dummy').click()
    }
    
    const editMovimiento = (mov) => { 
      let id = mov === undefined ? movid.value : mov.data.id
      getMovimiento(id)
    }

    watch(movimiento, () => {
      form.id = movimiento.value.id
      form.tipoDocumento = movimiento.value.tdocumento ? toRaw(tipoDocumentos.value.filter(function (itm) { return [movimiento.value.tdocumento.id].indexOf(itm.id) > -1 }))[0] : null
      form.tmovimiento = movimiento.value.tipo ? toRaw(tmovimientos.value.filter(function (itm) { return [movimiento.value.tipo.id].indexOf(itm.id) > -1 }))[0] : null
      form.tcamion = movimiento.value.tcamion ? toRaw(tcamiones.value.filter(function (itm) { return [movimiento.value.tcamion.id].indexOf(itm.id) > -1 }))[0] : null
      form.precio = movimiento.value.valor
      form.proveedor = movimiento.value.emisor ? toRaw(proveedores.value.filter(function (itm) { return [movimiento.value.emisor.id].indexOf(itm.id) > -1 }))[0] : null
      form.cliente = movimiento.value.receptor ? toRaw(clientes.value.filter(function (itm) { return [movimiento.value.receptor.id].indexOf(itm.id) > -1 }))[0] : null
      form.origen = movimiento.value.origen ? toRaw(origenes.value.filter(function (itm) { return [movimiento.value.origen.id].indexOf(itm.id) > -1 }))[0] : null
      form.destino = movimiento.value.destino ? toRaw(destinos.value.filter(function (itm) { return [movimiento.value.destino.id].indexOf(itm.id) > -1 }))[0] : null
      form.chofer = movimiento.value.chofer ? toRaw(choferes.value.filter(function (itm) { return [movimiento.value.chofer.id].indexOf(itm.id) > -1 }))[0] : null
      form.folio = movimiento.value.folio
      form.monto_total = movimiento.value.monto_total
      form.producto = movimiento.value.detalle
      form.fecha_emision = formatFecha(movimiento.value.fecha_emision)
      form.fecha = formatFecha(movimiento.value.fecha)
      form.patente_camion = movimiento.value.patente_camion
      form.observacion = movimiento.value.observacion

      es_normal.value = movimiento.value.tipo ? movimiento.value.tipo.tipo === 'NORMAL' : false

    }) 

    if (router.currentRoute.value.params.id) {
      fromMovimientos.value = true
      movid.value = router.currentRoute.value.params.id
      onMounted(editMovimiento)
    } else {
      fromMovimientos.value = false
      onMounted(() => {
        // document.getElementById('form_movimiento').show()
        loading.value = true
        cmanual()
      }) 
    }    

    const editMovto = (mov) => {
      getMovimiento(mov.data.id)
    }

    const clearForm = () => {
        movimiento.value = {}
        submitted.value = false
        movimientoDialog.value = true
        saving.value = false
        lineas.value = []

        form.id = null
        form.tipoDocumento = null
        form.tmovimiento = null
        form.tcamion = null
        form.precio = 0
        form.proveedor = null
        form.cliente = null
        form.origen = null     
        form.destino = null
        form.chofer = null
        form.folio = null
        form.monto_total = null
        form.producto = null    
        form.fecha_emision = null
        form.fecha = moment().toDate()
        form.patente_camion = ''
        form.observacion = ''
        //form.tipo_registro = 'WEB'

      if (router.currentRoute.value.params.id) 
        router.push({ name: 'movimientos.index' })  
    }

    const v$ = useVuelidate(rules, form)

    return {
      dt, 
      loading,
      saving,
      chofer,
      productos,
      lineas,
      choferes,
      tipoDocumentos,
      proveedores,
      filters,
      selectedMovimientos,
      deleteMovimientosDialog,
      deleteMovimientoDialog,
      movimientoDialog,
      submitted,
      filteredTipoDocumentos,
      filteredTCamiones,
      filteredTMovimientos,
      filteredProveedores,
      filteredClientes,
      filteredChoferes,
      filteredDestinos,
      filteredOrigenes,
      filteredProductos,
      selectedProductos,
      v$,
      form,
      messages,
      upperCase,
      confirmDeleteMovimiento,
      deleteSelectedMovimientos,
      deleteMovimiento,
      frmchofer,
      confirmDeleteSelected,
      searchTMovimiento,
      searchTCamion,
      searchTipoDocumento,
      searchProducto,
      searchProveedor,
      searchCliente,
      searchChofer,
      searchDestino,
      searchOrigen,
      saveMovimiento,
      storeMovimiento,
      formatCurrency,
      toggleDelete,
      first,
      lazyParams,
      cmanual,
      onPage,
      onSort,
      onFilter,
      dummyClick,
      initFilters,
      setDocumento,
      es_normal,
      valorizar,
      precio,
      movimientos,
      fromMovimientos,
      editMovimiento,
      movid,
      getMovimiento,
      editMovto,
      formatFecha,
      clearForm
    }
  },
}
</script>